import { ServiceIconShell } from '../ServiceIconShell';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Img } from '../../display/Img';
import { ServiceIconConfig } from './constants';
const getPropsWithDefaults = (props) => (Object.assign({ ariaHidden: false, hasBorder: true }, props));
export const ServiceIcon = (props) => {
    const { ariaHidden, serviceName, hasBorder, hasShadow, size, src, alt, hasWhiteBackground, } = getPropsWithDefaults(props);
    const { iconSize } = ServiceIconConfig[size];
    return (isolateComponent(ServiceIconShell, { size: size, hasBorder: hasBorder, hasShadow: hasShadow, hasWhiteBackground: hasWhiteBackground },
        isolateComponent(Img, { alt: alt || `${serviceName} logo`, ariaHidden: ariaHidden, borderRadius: 0, height: iconSize, objectFit: "contain", src: src, width: iconSize })));
};
//# sourceMappingURL=ServiceIcon.js.map
// @zapier/design-system@6.3.0 (1dc71580e)
